export default function Custom404() {
  return (
    <div id="welcome" className="404-page welcome-padd">
      <div className="container">
        <div className="text-center wh-box welcome-page">
          <h1>404</h1>
          <h2>Page not found!</h2>
          <p className="">The page you are looking for is not available!</p>
        </div>
      </div>
    </div>
  );
}
